<template>
  <div>
    <divisoria-descricao
      :titulo="'Endereço'"
      :descricao="'Adicione as informações sobre o endereço deste usuário'"
    />
    <b-row>
      <b-col class="mb-1">
        <b-form-checkbox
          id="checkbox-1"
          v-model="valueInner.residenteExterior"
          class="checkbox-residente-exterior"
          name="checkbox-1 "
          @change="limparEndereco($event)"
        >
          Residente no exterior
        </b-form-checkbox>
      </b-col>
    </b-row>
    <b-row>
      <b-col
        cols="3"
      >
        <cep-input
          :value="valueInner.cep"
          :disabled="valueInner.residenteExterior"
          @atualizar-endereco="enderecoBuscado"
        />
      </b-col>
      <b-form-group
        label="Endereço"
        class="col-md-6"
        :disabled="valueInner.residenteExterior"
      >
        <validation-provider
          #default="{ errors }"
          :rules="socioEmpresa && !valueInner.residenteExterior? 'required' : ''"
          name="Endereço"
        >
          <b-form-input
            v-model="valueInner.logradouro"
          />
          <small class="text-danger">{{ errors[0] }}</small>
        </validation-provider>
      </b-form-group>
      <b-form-group
        label="Número"
        class="col-md-3"
        :disabled="valueInner.residenteExterior"
      >
        <validation-provider
          #default="{ errors }"
          :rules="socioEmpresa && !valueInner.residenteExterior? 'required' : ''"
          name="Número"
        >
          <b-form-input
            v-model="valueInner.numero"
          />
          <small class="text-danger">{{ errors[0] }}</small>
        </validation-provider>
      </b-form-group>
    </b-row>
    <b-row>
      <b-form-group
        label="Complemento"
        class="col-md-3"
        :disabled="valueInner.residenteExterior"
      >
        <b-form-input
          v-model="valueInner.complemento"
        />
      </b-form-group>
      <b-form-group
        label="Bairro"
        class="col-md-4"
        :disabled="valueInner.residenteExterior"
      >
        <validation-provider
          #default="{ errors }"
          :rules="socioEmpresa && !valueInner.residenteExterior? 'required' : ''"
          name="Bairro"
        >
          <b-form-input
            v-model="valueInner.bairro"
          />
          <small class="text-danger">{{ errors[0] }}</small>
        </validation-provider>
      </b-form-group>
      <b-col cols="3">
        <legend class="col-form-label pt-0">
          Cidade
        </legend>
        <validation-provider
          #default="{ errors }"
          :rules="socioEmpresa && !valueInner.residenteExterior? 'required' : ''"
          name="Cidade"
        >
          <municipio-select
            v-model="valueInner.cidade"
            :disabled="valueInner.residenteExterior"
          />
          <small class="text-danger">{{ errors[0] }}</small>
        </validation-provider>
      </b-col>
      <b-col cols="2">
        <legend class="col-form-label pt-0">
          Estado
        </legend>
        <validation-provider
          #default="{ errors }"
          :rules="socioEmpresa && !valueInner.residenteExterior ? 'required' : ''"
          name="Estado"
        >
          <estado-select
            v-model="valueInner.uf"
            :disabled="valueInner.residenteExterior"
          />
          <small class="text-danger">{{ errors[0] }}</small>
        </validation-provider>
      </b-col>
    </b-row>

    <divisoria-descricao
      :titulo="'Anexo'"
      :descricao="'Adicione um anexo com documentos desse usuário'"
    />
    <b-row>
      <b-col cols="12">
        <upload-socio
          ref="uploadUsuario"
          :label="'Anexo de documento (CNH ou RG)'"
          :id-upload="'usuarioExterno'"
          :text="nomeArquivo"
          :visualizar="visualizarArquivo"
          @selecionado="arquivoSelecionado"
          @removido="$emit('removido')"
        />
      </b-col>
    </b-row>
  </div>
</template>
<style lang="scss">
.checkbox-residente-exterior label {
  font-size: 12px !important;
}
</style>
<script>
import { ValidationProvider } from 'vee-validate'
import api from '@/app-modulo/comuns/usuario-externo/shared/services/api'

export default {
  name: 'AbaEnderecoUsuarioExterno',
  components: {
    ValidationProvider,
    DivisoriaDescricao: () => import('@/shared/components/divisoria-descricao/DivisoriaDescricao.vue'),
    MunicipioSelect: () => import('@/shared/components/municipio-select/MunicipioSelect.vue'),
    EstadoSelect: () => import('@/shared/components/estado-select/EstadoSelect.vue'),
    UploadSocio: () => import('@/shared/components/upload-socio/UploadSocio.vue'),
    CepInput: () => import('@/@pilar/components/cep-input/CepInput.vue'),
  },
  props: {
    value: {
      type: Object,
      required: true,
    },
    empresaSocio: {
      type: Boolean,
      default: false,
    },
    nomeArquivo: {
      type: String,
      default: null,
    },
    idUsuario: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      valueInner: {},
      socioEmpresa: false,
      arquivo: null,
    }
  },
  watch: {
    value(value, oldValue) {
      if (value !== oldValue) {
        this.valueInner = value
      }
    },
    empresaSocio(value, oldValue) {
      if (value !== oldValue) {
        this.socioEmpresa = value
      }
    },
  },
  created() {
    this.valueInner = this.value
  },
  methods: {
    enderecoBuscado(value) {
      this.$set(this.valueInner, 'logradouro', value.logradouro)
      this.$set(this.valueInner, 'bairro', value.bairro)
      this.$set(this.valueInner, 'complemento', value.complemento)
      this.$set(this.valueInner, 'uf', value.uf)
      this.$set(this.valueInner, 'cidade', value.cidade)
      this.$set(this.valueInner, 'cep', value.cep)
    },
    arquivoSelecionado(name) {
      if (this.$refs.uploadUsuario && this.$refs.uploadUsuario.value[0]) {
        // eslint-disable-next-line prefer-destructuring
        this.arquivo = this.$refs.uploadUsuario.value[0]
      }

      this.$emit('selecionado-arquivo', name)
    },
    visualizarArquivo() {
      return api.getArquivoUsuario(this.idUsuario)
    },
    limparEndereco(event) {
      if (event) {
        this.valueInner = {
          cep: null,
          logradouro: null,
          numero: null,
          complemento: null,
          bairro: null,
          cidade: null,
          uf: null,
          residenteExterior: event,
        }
        this.$emit('limparEndereco', this.valueInner)
      }
    },
  },
}
</script>
